export default function Navbar({ children }) {
  return <header className="header">{children}</header>;
}
